module.exports = __webpack_public_path__ + "img/top-function-report-post.c3c69dae.jpg";